// extracted by mini-css-extract-plugin
export var wrapper = "cookiesPopup-module--wrapper--28u3t";
export var flex = "cookiesPopup-module--flex--cUgGw";
export var content = "cookiesPopup-module--content--1HIFs";
export var buttons = "cookiesPopup-module--buttons--2EHp_";